import script from "./playerControl.vue?vue&type=script&setup=true&name=playerControl&lang=js"
export * from "./playerControl.vue?vue&type=script&setup=true&name=playerControl&lang=js"

import "./playerControl.vue?vue&type=style&index=0&id=1bf64ed2&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf64ed2"]])

export default __exports__